import React, { ReactElement, useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import _isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { useQueryParam } from 'use-query-params';

import { getAbility } from 'containers/Ability/actions';
import { getPermissions } from 'containers/Permissions/actions';
import { DashboardLoading } from 'pages/public/Loading';

interface RestrictedRouteProps {
  element: ReactElement;
}

const RestrictedRoute = ({ element }: RestrictedRouteProps) => {
  const dispatch = useDispatch();
  const [token] = useQueryParam('token');
  const location = useLocation();
  const appLoading = useSelector((state: any) => state.global.loading, shallowEqual);
  const currentUser = useSelector((state: any) => state.global.currentUser, shallowEqual);
  const abilities = useSelector((state: any) => state.ability.sections, shallowEqual);
  const permissions = useSelector((state: any) => state.permissions.permissions, shallowEqual);

  useEffect(() => {
    if (_isEmpty(abilities) && currentUser) {
      dispatch(getAbility());
    }
    if (_isEmpty(permissions) && currentUser) {
      dispatch(getPermissions());
    }
  }, [abilities, dispatch, permissions, currentUser]);

  if (currentUser) {
    return element;
  }

  if (appLoading || !!token) {
    return <DashboardLoading />;
  }

  return <Navigate to="/signin" state={{ referrer: location }} replace />;
};

RestrictedRoute.propTypes = {
  element: PropTypes.element.isRequired
};

export default RestrictedRoute;
